import { Button, Card, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { Helmet } from "react-helmet";
import "./styles.scss";

import HeroImage from "../../assets/img/grupos/FOTO JERSU - SITE 01 (1).png";
import XiaomiLogo from "../../assets/img/grupos/Xiaomi.png";
import SamsungLogo from "../../assets/img/grupos/Samsung.png";
import MotorolaLogo from "../../assets/img/grupos/Motorola.png";
import AppleLogo from "../../assets/img/grupos/Apple.png";
import GeralLogo from "../../assets/img/grupos/Geral.png";

const brands = [
    { slug: "xiaomi", nome: "Xiaomi", logo: XiaomiLogo, cor: "#FF6900" },
    { slug: "samsung", nome: "Samsung", logo: SamsungLogo, cor: "#0F5CB8" },
    { slug: "motorola", nome: "Motorola", logo: MotorolaLogo, cor: "#1665B8" },
    { slug: "apple", nome: "Apple", logo: AppleLogo, cor: "#FFFFFF" },
    { slug: "ofertas", nome: "Geral!", logo: GeralLogo, cor: "#1F1F1F" },
];

const REDIRECT_BASE = "https://jersu.com.br/redirecionar";

export default function Grupos() {
    return (
        <>
            <Helmet title="Grupos de Ofertas - Jersu" />
            <div className="grupos-page">
                <section className="hero-section">
                    <div className="hero-content">
                        <h1>Participe dos meus grupos de oferta no WhatsApp e Telegram</h1>
                        <p>
                            Criamos canais no WhatsApp e Telegram para divulgar produtos em
                            promoção de fontes confiáveis; compartilhe a página com amigos para
                            economizar.
                        </p>
                    </div>
                    <div className="hero-image">
                        <Image src={HeroImage} alt="Jersu" />
                    </div>
                </section>

                <section className="nichos-section">
                    <h2>Grupos nichados!</h2>
                    <p className="nichos-subtitle">
                        Participe do grupo de ofertas exclusivo para a marca do seu próximo
                        celular!
                    </p>

                    <div className="brand-grid">
                        {brands.map((brand) => (
                            <div key={brand.slug} className="brand-item">
                                <Card
                                    className="brand-card"
                                    style={{ backgroundColor: brand.cor }}
                                >
                                    <Card.Body>
                                        <Image
                                            src={brand.logo}
                                            alt={brand.nome}
                                            className="brand-logo"
                                        />
                                    </Card.Body>
                                </Card>
                                <p className="brand-name">{brand.nome}</p>
                                <Button
                                    variant="success"
                                    href={`${REDIRECT_BASE}?tipo=${brand.slug}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="entrar-btn"
                                >
                                    Entrar
                                </Button>
                            </div>
                        ))}
                    </div>
                </section>

                <footer className="footer">
                    <div className="footer-left">
                        <h3>Quem somos</h3>
                        <Link to="/entrar" className="footer-link">Entrar</Link>
                        <Link to="/sobre" className="footer-link">Sobre</Link>
                    </div>
                    <div className="footer-right">
                        <h3>Contato</h3>
                        <p className="footer-email">contatojersu@gmail.com</p>
                        <div className="social-icons">
                            <a href="https://www.instagram.com/jeersu/" target="_blank" rel="noreferrer">
                                <FaInstagram />
                            </a>
                            <a href="https://www.facebook.com/jeersu" target="_blank" rel="noreferrer">
                                <FaFacebook />
                            </a>
                            <a href="https://www.youtube.com/@Jersu" target="_blank" rel="noreferrer">
                                <FaYoutube />
                            </a>
                            <a href="https://jersu.com.br/redirecionar?tipo=ofertas" target="_blank" rel="noreferrer">
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}
